<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="layout m-newList">
			<div class="list_count no-padding-top">
				<div class="wow bounceInUp animated">
					<img class="list_img" :src="zidiyiData.news_center.files" />
				</div>
				<div class="list_info">
					<div class="info_tit wow bounceInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
						<div class="tit_left" v-if="id==item.id" v-for="(item,i) in list">
							<span>{{item.cn_name}}</span>
							<el-divider direction="vertical"></el-divider>
							<span class="text-uppercase">{{item.en_name}}</span>
						</div>

					</div>
					<!-- 列表 -->

					<div class="liebiao_list wow bounceInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
						<div class="liebiao_info css3 wow bounceInUp animated" v-for="(item,index) in arcList"
							data-wow-delay="0.5s" data-wow-offset='0' :key="item.id">
							<div class="info_left col-xs-12 col-lg-3">
								<img class="css3" :src="item.image" @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" />
							</div>
							<div class="info_right col-xs-12 col-lg-9" @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
								<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
								<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
								<div class="right_down">
									<span>{{item.publishtime_text}}</span>
									<div class="right_down_div">
										<span class="commo_span">
											<img class="eye" src="@/assets/news/eye.svg" />
											<span>{{item.view}}</span>
										</span>
										<span class="commo_span">
											<img src="@/assets/news/comment.svg" />
											<span>{{item.comment_num}}</span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage4" background :page-size="per_page"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		archives_list
	} from "@/api/api"

	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'list',
		data() {
			return {
				index: 0,
				currentPage4: 1,
				parent_id: 10,
				id: '',
				list: [], //
				jx_index: 29,
				per_page: 10,
				page: 1,
				zidiyiData: {
					news_center: {
						files: ''
					}
				},
				arcList: [], //内容列表
				content: {}, //内容详情
				total: 0,
				company_id: 1, //公司ID
				banner: '',
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			this.getChannelList()
			this.getBanner();
			this.addLocatPath()
			this.parent_id = this.$route.query.parent_id



			this.id = this.$route.query.id
			this.jx_index = this.$route.query.id
			if (this.$route.query.index) {
				this.index = this.$route.query.index
			}

			this.getZidiyiData() //自定义图片

			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {
			this.getArchivesList(this.jx_index)
		},
		methods: {
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},

			addLocatPath() {
				let data = {
					directions: '新闻中心',
					path: window.location.href
				}

				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {}).catch(err => {});
			},
			getBanner() {
				let data = {
					company_id: this.company_id,
					tag: '新闻中心'
				}
				this.$axios.get("/api/jx/get_banner", {
					params: data
				}).then((res) => {


					if (res.code == 1) {
						this.banner = res.data.data

					}
				}).catch(err => {});
			},
			getChannelList() {
				let data = {
					parent_id: this.parent_id
				}
				this.$axios.get("/api/jx/channel_list", {
					params: data
				}).then((res) => {

					if (res.code == 1) {
						this.list = res.data.data
						console.log(this.list);
					}
				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page,
				}
				this.$axios.get("/api/jx/archives_list", {
					params: data
				}).then((res) => {
				
					if (res.data.code == 1) {
						
						res.data.data.data.map(item=>{
							item.en_cont=item.en_digest?item.en_digest:this.filtersText(item.en_content)
							item.cn_cont=item.cn_digest?item.cn_digest:this.filtersText(item.cn_content)
						})
						
						this.arcList = res.data.data.data
						
	
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},
			go(id) {

				this.$router.push({
					path: `new_detail?id=${id}`
				})
				// window.open(`new_detail?id=${id}`,'_blank')
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {
					this.zidiyiData = res.data.data
				}).catch(err => {});
			},
			choose_type(num) {
				this.index = num
				this.jx_index = this.list[this.index].id
				this.getArchivesList(this.list[this.index].id)

			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.getArchivesList(this.jx_index)
				console.log(this.jx_index);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	a {
		color: #42b983;
	}

	.col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.m-newList {
		background: #fff;

		.list_count {
			padding: 30px;
		}

		.list_info {
			margin: 50px auto;
			max-width: 1400px;

			.list_img {
				width: 100%;
			}

			.info_tit {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;

				.active {
					border: 2px solid #006170;
					box-shadow: 5px 7px 10px #cddadc;
					color: #000;
				}

				.tit_left {
					span:first-child {
						font-size: 30px;
						color: #000;
						font-weight: bold;
					}

					span:last-child {
						font-size: 14px;
						color: #999;
					}

				}

				.tit_right {
					display: flex;

					span {
						height: 50px;
						line-height: 50px;
						padding: 0 15px;
						text-align: center;
						color: #999;
						font-size: 14px;
						display: block;
						border: 1px solid #eee;
						margin-left: 20px;
					}

				}
			}
		}

		.hover_span {
			cursor: pointer;
		}

		.liebiao_list {
			// margin-top: 50px;
		}

		.liebiao_info {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			position: relative;
			padding: 30px;
			border-bottom: 1px solid #f0f4f5;
			cursor: pointer;

			.info_left {
				margin-right: 30px;
				overflow: hidden;
				position: relative;
				z-index: 5;

				img {
					width: 100%;
					height: 200px;
					object-fit: cover;
				}

				img:hover {
					transform: scale(1.2)
				}

			}
		}

		.liebiao_info:hover {
			background: #f0f4f5;
		}

		.info_right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			position: relative;
			z-index: 5;

			.right_down_div {
				display: flex;
				align-items: center;
			}

			.right_tit {
				font-size: 24px;
				color: #000;
				padding-top: 10px;
			}

			.right_tit:hover {
				color: #006170;
			}

			.jieshao {
				font-size: 14px;
				color: #666666;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}


			.jieshao:hover {
				opacity: 0.8;
			}


		}

		.right_down {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			font-size: 12px;
			color: #999;
		}

	}


	.commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;

		img {
			width: 20px;
			margin-right: 5px;
		}
	}




	.m-newList .fenye {
		margin-top: 50px;
		text-align: center;
	}

	.m-newList .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}

	@media screen and (max-width: 1400px) {
		.m-newList .list_info {
			width: 100%;
		}
	}
</style>
